import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BaseDialog } from '@library-shared/base/base-dialog.component';
import { EventBusService } from '@library-shared/services/event-bus/event-bus.service';
import { DxButtonComponent } from 'devextreme-angular';

@Component({
    selector: 'app-confirm-payment-dialog',
    templateUrl: './confirm-payment-dialog.component.html',
    styleUrls: ['./confirm-payment-dialog.component.scss'],
    standalone: false
})
export class ConfirmPaymentDialogComponent extends BaseDialog implements OnInit {
    @ViewChild('submitButton') submitButton: DxButtonComponent;
    @Input() validationGroup;
    @Output() completed = new EventEmitter<boolean>();

    finalPaymentAmount = 0;

    constructor(public eventBusService: EventBusService) {
        super(eventBusService);
    }

    ngOnInit() {}

    showDialog(finalPaymentAmount: number) {
        this.finalPaymentAmount = finalPaymentAmount;
        this.showDialogBase();
    }

    onShown() {
        setTimeout(() => {
            this.submitButton.instance.focus();
        }, 0);
    }

    onSubmit(e: any): void {
        this.completed.emit(true);
        this.closeDialogBase();
    }

    onCancel(e: any): void {
        this.completed.emit(false);
        this.closeDialogBase();
    }
}
